import PropTypes from 'prop-types';

const searchDataPropType = PropTypes.shape({
    results: PropTypes.arrayOf(
        PropTypes.shape({
            formatted: PropTypes.shape({
                name: PropTypes.string,
                // eslint-disable-next-line react/forbid-prop-types
                address: PropTypes.object,
                dob: PropTypes.string,
                phone: PropTypes.string,
                gender: PropTypes.string,
            }),
        }),
    ),
    running: PropTypes.bool,
    error: PropTypes.string,
});

export default searchDataPropType;
